module.exports = __webpack_public_path__ + "img/electric_no_zone.36122040.svg";